import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { PalaceHotelHome } from './pages/PalaceHotelHome';
import { PalaceHotelRooms } from './pages/PalaceHotelRooms';
import { PalaceHotelDining } from './pages/PalaceHotelDining';
export function PalaceHotelApp() {
  return <Routes data-id="element-862">
      <Route path="/" element={<PalaceHotelHome data-id="element-864" />} data-id="element-863" />
      <Route path="/rooms" element={<PalaceHotelRooms data-id="element-866" />} data-id="element-865" />
      <Route path="/dining" element={<PalaceHotelDining data-id="element-868" />} data-id="element-867" />
    </Routes>;
}